import { mockContactData, companyInfo } from '../../data/mockData';
import { trackAnalyticsEvent } from '../../hooks/useAnalytics';

const Footer = () => {
  const handleEmailClick = () => {
    trackAnalyticsEvent('conversion', { 
      event: 'footer_email_click', 
      page: window.location.pathname 
    });
  };

  return (
    <footer className="bg-primary-secondary border-t border-white/10 py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/media/logo.png" 
                alt="Marvin AI Logo" 
                className="w-8 h-8 rounded-lg"
              />
              <span className="text-xl font-display font-semibold text-white">
                Marvin AI
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {companyInfo.description}
            </p>
            <p className="text-gray-500 text-xs">
              © 2025 {mockContactData.company}. All rights reserved.
            </p>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-lg">Contact</h3>
            <div className="space-y-2 text-sm">
              <p className="text-gray-400">{mockContactData.address}</p>
              <p className="text-gray-400">
                <a 
                  href={`mailto:${mockContactData.email}`} 
                  onClick={handleEmailClick}
                  className="hover:text-primary-cyan transition-colors"
                >
                  {mockContactData.email}
                </a>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-lg">Services</h3>
            <div className="space-y-2 text-sm">
              <a href="#services" className="block text-gray-400 hover:text-primary-cyan transition-colors">
                Energy Forecasting
              </a>
              <a href="#services" className="block text-gray-400 hover:text-primary-cyan transition-colors">
                Market Intelligence
              </a>
              <a href="#services" className="block text-gray-400 hover:text-primary-cyan transition-colors">
                Asset Optimization
              </a>
              <a href="#technology" className="block text-gray-400 hover:text-primary-cyan transition-colors">
                Technology
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

